var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C4.47754 0 0 4.47705 0 10C0 15.5229 4.47754 20 10 20C15.5225 20 20 15.5229 20 10C20 4.47705 15.5225 0 10 0ZM3.70703 9.79297C3.31641 10.1836 3.31641 10.8164 3.70703 11.207L7.29297 14.793C7.68359 15.1836 8.31641 15.1836 8.70703 14.793L16.293 7.20703C16.6836 6.81641 16.6836 6.18359 16.293 5.79297L16.207 5.70703C15.8164 5.31641 15.1836 5.31641 14.793 5.70703L8 12.5L5.20703 9.70703C5.0459 9.5459 4.84375 9.45117 4.63379 9.42285C4.33594 9.38281 4.02246 9.47754 3.79297 9.70703L3.70703 9.79297Z",
    fill: "#28A879"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/iconCheck.4a25aa910f7a2e2f69fb92696b390820.svg";
export { ForwardRef as ReactComponent };